import { PosterGroup, PosterSize } from '../definitions/poster';

export const allPosterSizes: PosterSize[] = ['70x100', '50x70', 'a3', 'a4'];

export const posterGroups: PosterGroup[] = [
    {
        candidates: '12',
        posters: [
            { size: '70x100', text: 'Lag PDF-plakat 70x100' },
            { size: '50x70', text: 'Lag PDF-plakat 50x70' },
            { size: 'a3', text: 'Lag PDF-plakat A3' },
            { size: 'a4', text: 'Lag PDF-plakat A4' },
        ],
    },
    {
        candidates: '15',
        posters: [
            { size: '70x100', text: 'Lag PDF-plakat 70x100' },
            { size: '50x70', text: 'Lag PDF-plakat 50x70' },
            { size: 'a3', text: 'Lag PDF-plakat A3' },
            { size: 'a4', text: 'Lag PDF-plakat A4' },
        ],
    },
];

export const fallbackLayout: PosterGroup['candidates'] = '12';
export const fallbackSize: PosterSize = '50x70';

export const BLEED_MM = 3;

export const posterSizeDimensions: Record<PosterSize, { width: number; height: number }> = {
    '70x100': { width: 700, height: 1000 },
    '50x70': { width: 500, height: 700 },
    a3: { width: 300, height: 420 },
    a4: { width: 210, height: 297 },
};
